var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data.open
    ? _c("div", { staticClass: "info-block" }, [
        false
          ? _c(
              "div",
              { staticClass: "alert alert-warning alert_message shadow" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm.data.client && _vm.data.client.blackList
                  ? [
                      _c("p", [_vm._v("Добрый день!")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Да, смотрю, этот препарат есть в наличии на складе, последняя упаковка. Но вижу что он отложен для клиента,\n        до завтрашнего утра."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Так что к сожалению - не смогу принять заявку на него. Мне очень жаль."
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                [
                  _c("p", [
                    _vm._v(
                      "Если клиент спрашивает про чек или сертификат, то говорим:"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Да, конечно, есть и чек, и сертификат, все по закону."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Сейчас разговариваю с Вами, и смотрю по компьютеру - вижу препарат есть в наличии на складе, последняя\n        упаковка. Но вижу что он отложен для клиента, до завтрашнего утра."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Так что к сожалению - не смогу принять заявку на него. Мне очень жаль."
                    ),
                  ]),
                ],
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default btn-xs btn-close",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.data.open = false
                  },
                },
              },
              [_vm._v("\n        Закрыть\n      ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "client_block" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", [
                  _c("p", [
                    _vm._v("Имя: "),
                    _c("strong", [_vm._v(_vm._s(_vm.data.client.name))]),
                  ]),
                  _vm._v(" "),
                  _vm.data.client.registered
                    ? _c("p", { staticClass: "text-muted fs-12" }, [
                        _vm._v(
                          "Регистрация: " +
                            _vm._s(_vm.printDate(_vm.data.client.registered))
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex--grow" }, [
                _c("p", [
                  _vm._v("Входящий номер: "),
                  _c("strong", [_vm._v(_vm._s(_vm.data.phoneNum))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info btn-xs",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.copyToBuffer(_vm.data.phoneNum)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-copy" })]
                  ),
                ]),
                _vm._v(" "),
                _vm.data.client.blackList
                  ? _c("div", [
                      _c("p", { staticClass: "badge badge-danger" }, [
                        _vm._v("Номер в черном списке"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-muted fs-12" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.data.client.blackList.comments[
                                _vm.data.client.blackList.comments.length - 1
                              ].text
                            )
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Звонит на: "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.data.toPhoneNum) + " "),
                    _c("span", { staticClass: "fs-18 badge badge-info" }, [
                      _vm._v(_vm._s(_vm.data.title)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.data.client.last_order
                  ? _c("p", [
                      _vm._v("Заявка:\n            "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info btn-xs",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.loadOrder(
                                _vm.data.client.last_order.id
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.data.client.last_order.id) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$AllProjects[_vm.data.client.last_order.site_id]
                              .title
                          ) +
                          "\n            " +
                          _vm._s(
                            _vm.$AllCities[_vm.data.client.last_order.city_id]
                              .short_name
                          ) +
                          " "
                      ),
                      _c("span", { staticClass: "badge badge-dark" }, [
                        _vm._v(_vm._s(_vm.data.client.last_order.status_label)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "text-right flex" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-xs",
                      on: { click: _vm.createOrder },
                    },
                    [_vm._v("Создать заявку с текущим клиентом")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Рекомендации для проекта ЛШ!")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "avatar" }, [
      _c("img", { attrs: { src: "/assets/img/avatars/gomer.jpg", alt: "" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }